export const JIT_MODULE_NAME = 'jit-consent';
export const JIT_MANDATORY_MODULE_NAME = 'jit-consent-mandatory';
export const SIGN_UP_CONSENT_MODULE_NAME = 'sign-up-consent';

export const CONSENT_CACHE_MILLIS = 1000 * 60 * 60 * 24;
